import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateProcessCodeQuery,
  GenerateProcessCodeQuery,
  ProcessApi,
} from 'api';

export const createProcess = createAsyncThunk(
  'process/createProcess',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProcessApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProcess = createAsyncThunk(
  'process/updateProcess',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProcessApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiStepForProcess = createAsyncThunk(
  'process/createMultiStep',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProcessApi.createMultiStep(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStepForProcess = createAsyncThunk(
  'process/updateStep',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProcessApi.updateStep(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createStepPropertyForProcess = createAsyncThunk(
  'process/createStepProperty',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProcessApi.createStepProperty(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStepPropertyForProcess = createAsyncThunk(
  'process/updateStepProperty',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProcessApi.updateStepProperty(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeStepPropertyForProcess = createAsyncThunk(
  'process/removeStepProperty',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ProcessApi.removeStepProperty(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateProcessCode = createAsyncThunk(
  'area/checkDuplicateProcessCode',
  async (query: CheckDuplicateProcessCodeQuery, { rejectWithValue }) => {
    try {
      const response = await ProcessApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateProcessCode = createAsyncThunk(
  'area/generateProcessCode',
  async (query: GenerateProcessCodeQuery, { rejectWithValue }) => {
    try {
      const response = await ProcessApi.generateCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const processSlice = createSlice({
  name: 'process',
  initialState: {
    tableList: [],
    list: [],
    reloadFlag: false,
    savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
    savedList: [],
  },
  reducers: {
    reloadProcess(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationProcess(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListProcess(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: processReducer } = processSlice;

export const {
  reloadProcess,
  updateSavedPaginationProcess,
  updateSavedListProcess,
} = actions;

export default processReducer;
